 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-090891be":"2310f3a8","chunk-0a4c994b":"ab4de1c7","chunk-1f4d9826":"61c10f52","chunk-2d0c0658":"7009421b","chunk-2d0e59a3":"ef59220f","chunk-2d0e5ad6":"2f714de1","chunk-2d0e5ba1":"96a41da4","chunk-2d2105ac":"b58df98e","chunk-2d22a0f0":"56afe47d","chunk-2d230115":"82f719d7","chunk-2d422171":"d54e0376","chunk-316afd9e":"241ecc38","chunk-1d0606c1":"306b981a","chunk-4c7b8534":"0152522a","chunk-4d0a5876":"342c7a7d","chunk-517e90b8":"81289492","chunk-64344d21":"ed054aba","chunk-6587fb08":"e526b263","chunk-670719df":"c350f2e0","chunk-7a68602d":"a33eee0a","chunk-39e4a308":"c6e51766","chunk-4e1a31a2":"e800c308","chunk-6291fa3e":"11267d28","chunk-da832570":"2b07f418","chunk-834a5774":"98b2b47a","chunk-8cb4356c":"ec30a129","chunk-9a598a2e":"261123f4","chunk-aeb7c490":"49b1a9ab","chunk-c2b320a6":"bd085111","chunk-e2fa9f6c":"b045a4d1","chunk-01e0d49e":"05d8d895","chunk-22e3b547":"7dd494d2","chunk-2fbe484f":"26ca11b5","chunk-63a9bf69":"cd375b39","chunk-6bdfbcd2":"642350d3","chunk-11787c32":"96f4bcdb","chunk-161cde7c":"9a2fcdf6","chunk-1c8b29c9":"f21b6ce8","chunk-1ca4b7de":"7959ccd8","chunk-4c38df48":"3cc4951e","chunk-87dbe98c":"4bcd619a","chunk-3c6d3670":"1a7f6f5b","chunk-7d9f337c":"852e2c66","chunk-9833d2cc":"11a43541","chunk-ba49a4d6":"5b2bbd9a","chunk-c623330e":"68336a84","chunk-79d2923e":"ce167ecb","chunk-c3b9847c":"3b688346","chunk-ef0031fc":"c212b1e7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-090891be":1,"chunk-0a4c994b":1,"chunk-1f4d9826":1,"chunk-2d422171":1,"chunk-1d0606c1":1,"chunk-4c7b8534":1,"chunk-4d0a5876":1,"chunk-517e90b8":1,"chunk-64344d21":1,"chunk-6587fb08":1,"chunk-670719df":1,"chunk-39e4a308":1,"chunk-4e1a31a2":1,"chunk-6291fa3e":1,"chunk-da832570":1,"chunk-834a5774":1,"chunk-8cb4356c":1,"chunk-9a598a2e":1,"chunk-aeb7c490":1,"chunk-c2b320a6":1,"chunk-01e0d49e":1,"chunk-22e3b547":1,"chunk-2fbe484f":1,"chunk-63a9bf69":1,"chunk-11787c32":1,"chunk-161cde7c":1,"chunk-1c8b29c9":1,"chunk-4c38df48":1,"chunk-87dbe98c":1,"chunk-3c6d3670":1,"chunk-7d9f337c":1,"chunk-9833d2cc":1,"chunk-ba49a4d6":1,"chunk-c623330e":1,"chunk-79d2923e":1,"chunk-ef0031fc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-090891be":"32a7dcc0","chunk-0a4c994b":"6e4e056e","chunk-1f4d9826":"d78e637a","chunk-2d0c0658":"31d6cfe0","chunk-2d0e59a3":"31d6cfe0","chunk-2d0e5ad6":"31d6cfe0","chunk-2d0e5ba1":"31d6cfe0","chunk-2d2105ac":"31d6cfe0","chunk-2d22a0f0":"31d6cfe0","chunk-2d230115":"31d6cfe0","chunk-2d422171":"5015ed3a","chunk-316afd9e":"31d6cfe0","chunk-1d0606c1":"0564be51","chunk-4c7b8534":"b1bd1fd1","chunk-4d0a5876":"d0506b56","chunk-517e90b8":"81e9fac4","chunk-64344d21":"2f03085e","chunk-6587fb08":"51a359bd","chunk-670719df":"3e2c94bd","chunk-7a68602d":"31d6cfe0","chunk-39e4a308":"be8167d3","chunk-4e1a31a2":"f9b6c061","chunk-6291fa3e":"49201c3d","chunk-da832570":"f0639add","chunk-834a5774":"0df09c0c","chunk-8cb4356c":"faec5084","chunk-9a598a2e":"ee2ca20f","chunk-aeb7c490":"a9891c00","chunk-c2b320a6":"c8af8300","chunk-e2fa9f6c":"31d6cfe0","chunk-01e0d49e":"2d4e7b24","chunk-22e3b547":"ca8d14e2","chunk-2fbe484f":"935f0dfd","chunk-63a9bf69":"875316a1","chunk-6bdfbcd2":"31d6cfe0","chunk-11787c32":"f6f4cb9f","chunk-161cde7c":"993d398f","chunk-1c8b29c9":"fe03011b","chunk-1ca4b7de":"31d6cfe0","chunk-4c38df48":"54cbcc64","chunk-87dbe98c":"ea9302a3","chunk-3c6d3670":"de4e774e","chunk-7d9f337c":"a55a24ae","chunk-9833d2cc":"979d0edc","chunk-ba49a4d6":"f179b161","chunk-c623330e":"f041c810","chunk-79d2923e":"b97a4508","chunk-c3b9847c":"31d6cfe0","chunk-ef0031fc":"2292bcba"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://business-oss.ciftis.org/sunshine-web-bundle/fe-h5/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
